import { createElement } from '../utils.js';
import text from '../constants.js';
import renderIcon from './renderIcon.js';

export default function renderControl (componentElement, data, exceptions = []) {
    const container = createElement('div', {
        className: 'x-control'
    })
    if(!exceptions.includes('required')){
        const checked = data.required ? 'checked' : '';
        container.appendChild(createElement('label', {
            className: 'switch',
            title: text.REQUIRED,
            innerHTML: `<input type="checkbox" class="x-required" ${checked}><span></span>`
        }));
        container.appendChild(createElement('span', {
            innerText: text.REQUIRED
        }))
        container.appendChild(createElement('span', {
            className: 'x-separator'
        }))    
    }
    if(!exceptions.includes('up')){
        container.appendChild(createElement('span', {
            className: 'x-control-item',
            title: text.UP,
            dataset: { control: 'up' },
            innerHTML: renderIcon('up', { width:'12px', style:'fill:gray;' })
        }));
    }
    if(!exceptions.includes('down')){
        container.appendChild(createElement('span', {
            className: 'x-control-item',
            title: text.DOWN,
            dataset: { control: 'down' },
            innerHTML: renderIcon('down', { width:'12px', style:'fill:gray;' })
        }));
    }
    if(!exceptions.includes('down')){
        container.appendChild(createElement('span', {
            className: 'x-control-item',
            title: text.DELETE,
            dataset: { control: 'delete' },
            innerHTML: renderIcon('delete', { width:'12px', style:'fill:gray;' })
        }));
    }
    container.querySelectorAll('.x-control-item').forEach(x => {
        x.addEventListener('click', () => {
            const control = x.dataset.control;
            switch (control) {
                case 'up':
                    if (componentElement.previousElementSibling) componentElement.previousElementSibling.before(componentElement);
                    break;
                case 'down':
                    if (componentElement.nextElementSibling) componentElement.nextElementSibling.after(componentElement);
                    break;
                case 'delete':
                    if (confirm(text.DELETE_CONFIRM)) {
                        x.closest('.x-component').remove();
                    }
                    break;
            }
        })
    })
    return container;
}